import { useEffect, useState } from 'react';
import { selectResourcesNames, selectResourcesOptions } from 'entities/hallmap';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { Option } from 'shared/types';

import { usePaginationFilter } from 'shared/lib/pagination';

import { MultiValue } from 'react-select';
import {
	selectOrderSlugTagsMap,
	selectOrderTagsOptions,
	selectOrderTagsSlugNamesMap,
	selectTagsForOrderMap,
} from 'entities/tags';
import { TCheckbox } from 'shared/ui/checkbox';
import { selectPlaces } from 'entities/toolbar/places';
import { Filter, statusesMap } from 'entities/orders';
import { useModal } from 'shared/lib/modal';
import { PaginationHook } from 'shared/lib/pagination';
import { getPaymentProviders } from 'entities/orders/model/ordersThunk';
import { selectPaymentProvidersMap } from 'entities/orders/model/selectors';
import { depositMap } from '../../helpers/data/map';
import { selectSettingDefaultPerson } from 'entities/settings';

export const useOrderFilter = () => {
	const resourcesOptions: Option[] = useAppSelector(selectResourcesOptions);
	const tagsOptions = useAppSelector(selectOrderTagsOptions);
	const tagsForOrderMap = useAppSelector(selectTagsForOrderMap);
	const places = useAppSelector(selectPlaces);
	const tagsSlugMap = useAppSelector(selectOrderTagsSlugNamesMap);
	const tagsNamesBySlug = useAppSelector(selectOrderSlugTagsMap);
	const resourcesNames = useAppSelector(selectResourcesNames);
	const paymentProvidersMap = useAppSelector(selectPaymentProvidersMap);
  const defaultPersonId = useAppSelector(selectSettingDefaultPerson);

	const { updateFilters, fetchDataWithDispatch, resetFilters } = usePaginationFilter() as PaginationHook;
	const { closeModal } = useModal();
	const filters = usePaginationFilter()?.filters as unknown as Filter;

	const [selectedResourcesOptions, setResourcesOptions] = useState<Option[] | []>([]);
	const [selectedTagsOptions, setTagsOptions] = useState<Option[] & { color: string } | []>([]);
	const [selectedStatusCheckbox, setSelectedStatusCheckbox] = useState<TCheckbox[] | []>([]);
	const [selectedPlacesCheckbox, setSelectedPlacesCheckbox] = useState<TCheckbox[] | []>([]);
	const [selectedConfirmedCheckbox, setSelectedConfirmedCheckbox] = useState<TCheckbox | null>(null);
  const [isProvidersGetted,setIsProvidersGetted] = useState<boolean>(false);
	const [selectedByPassCheckbox, setSelectedByPassCheckbox] = useState<TCheckbox | null>(null);
	const [selectedHoldResourcesCheckbox, setSelectedHoldResourcesCheckbox] = useState<TCheckbox | null>(null);
	const [selectedWithoutPerson, setSelectedWithoutPerson] = useState<TCheckbox | null>(null);
  const [ isGuestAppointment, setIsGuestAppointment ] = useState<TCheckbox | null>(null)
  
  const [depositStatusOptions, setDepositStatusOptions] = useState<Option[]>([])
  const [selectedDepositStatusOptions, setSelectedDepositStatusOptions] = useState<Option[]>([]);
  const [paymentProviderOptions, setPaymentProviderOptions] = useState<Option[]>([])
  const [selectedPaymentProviderOptions, setselectedPaymentProviderOptions] = useState<Option[]>([])

  const dispatch = useAppDispatch();

	const changeResources = (resources: MultiValue<Option>) => {
		const resourcesIds = resources.map(resource => resource.value);
		if (!resourcesIds.length) {
			delete filters.appointment__resources;
			resetFilters({ newFilters: filters, withRequest: false });
		} else {
			updateFilters({ appointment__resources: resourcesIds });
		}
	};

	const changeTags = (tagsOptions: MultiValue<Option>) => {
		const tags = tagsOptions.map(tag => tagsSlugMap.get(tag.label));

		if (!tags.length) {
			delete filters.tags;
			resetFilters({ newFilters: filters, withRequest: false });
		} else {
			updateFilters({ tags });
		}
	};

	const changeParticipantsStart = (participants_count__gte: string) => {
		const filter: Filter = { participants_count__gte };
		const participantslte = Number(filters?.participants_count__lte);
		if (!participants_count__gte) {
			delete filters.participants_count__gte;
			updateFilters(filters);
		} else {
			if (
				participantslte &&
				Number(participants_count__gte) > participantslte
			) {
				filter.participants_count__gte = participantslte.toString();
			}
			updateFilters(filter);
		}
	};

	const changeParticipantsEnd = (participants_count__lte: string) => {
		const filter: Filter = { participants_count__lte };
		const participantsgte = Number(filters?.participants_count__gte);
		if (!participants_count__lte) {
			delete filters.participants_count__lte;
			updateFilters(filters);
		} else {
			if (
				participantsgte &&
				Number(participants_count__lte) < participantsgte
			) {
				filter.participants_count__lte = participantsgte.toString();
			}
			updateFilters(filter);
		}
	};

	const changeStatusCheckbox = (checkboxes: TCheckbox[] | []) => {
		if (!checkboxes.length) {
			delete filters.status;
			resetFilters({ newFilters: filters, withRequest: false });
		} else {
			const status = checkboxes.map(checkbox => checkbox.id);
			const filter: Filter = { status };
			setSelectedStatusCheckbox(checkboxes);
			updateFilters(filter);
		}
	};

	const changePlacesCheckbox = (checkboxes: TCheckbox[] | []) => {
		if (!checkboxes.length) {
			delete filters.places;
			resetFilters({ newFilters: filters, withRequest: false });
		} else {
			const places = checkboxes.map(checkbox => checkbox.id);
			const filter: Filter = { places };

			setSelectedPlacesCheckbox(checkboxes);
			updateFilters(filter);
		}
	};

	const changeConfirmed = (checkbox: TCheckbox | null) => {
		if (!checkbox) {
			delete filters.is_confirmed;
			resetFilters({ newFilters: filters, withRequest: false });
		} else {
			const is_confirmed = checkbox.id;
			const filter: Filter = { is_confirmed };
			setSelectedConfirmedCheckbox({
				id: is_confirmed,
				name: is_confirmed ? 'Да' : 'Нет',
			});
			updateFilters(filter);
		}
	};


  const changeDepositStatus = (options: MultiValue<Option>) => {
    const deposit__status = options.map(el => el.value);

    if (!options.length) {
      delete filters.deposit__status;
			resetFilters({ newFilters: filters, withRequest: false });
    } else {
			updateFilters({ deposit__status });
    }
  };

  const changePaymentProvider = (options: MultiValue<Option>) => {
    const deposit__provider = options.map(el => el.value);

    if (!options.length) {
      delete filters.deposit__provider;
			resetFilters({ newFilters: filters, withRequest: false });
    } else {
			updateFilters({ deposit__provider });
    }
  };

  const changeByPass = (checkbox: TCheckbox | null) => {
		if (!checkbox) {
			delete filters.appointment__bypass;
			resetFilters({ newFilters: filters, withRequest: false });
		} else {
			const appointment__bypass = checkbox.id;
			const filter: Filter = { appointment__bypass };
			setSelectedByPassCheckbox({
				id: appointment__bypass,
				name: appointment__bypass ? 'Да' : 'Нет',
			});
			updateFilters(filter);
		}
  }

  const changeHoldResources = (checkbox: TCheckbox | null) => {
		if (!checkbox) {
			delete filters.appointment__hold_resources;
			resetFilters({ newFilters: filters, withRequest: false });
		} else {
			const appointment__hold_resources = checkbox.id;
			const filter: Filter = { appointment__hold_resources };
			setSelectedHoldResourcesCheckbox({
				id: appointment__hold_resources,
				name: appointment__hold_resources ? 'Да' : 'Нет',
			});
			updateFilters(filter);
		}
  }

  const changeWithoutPerson = (checkbox: TCheckbox | null) => {
    if (checkbox?.id === 'true') {
			const filter: Filter = { person: defaultPersonId };
			updateFilters(filter);
    } else {
			delete filters.person;
			resetFilters({ newFilters: filters, withRequest: false });
		}
  }

  const changeIsGuestAppointment = (checkbox: TCheckbox | null) => {
    if (!checkbox) {
			delete filters.is_guest_appointment;
			return resetFilters({ newFilters: filters, withRequest: false });
    }

    const filter: Filter = { is_guest_appointment: checkbox.id === 'true' };
    updateFilters(filter);
  }


	const getOrdersByFilter = () => {
		fetchDataWithDispatch();
		closeModal();
	};

	const reset = () => {
		setResourcesOptions([]);
		setTagsOptions([]);
		setSelectedStatusCheckbox([]);
		setSelectedPlacesCheckbox([]);
    setSelectedDepositStatusOptions([]);
		setSelectedConfirmedCheckbox(null);
		setSelectedByPassCheckbox(null);
		closeModal();
	};

	useEffect(() => {
		if (filters) {
			if (filters.appointment__resources) {
				const resourcesOptions = filters.appointment__resources.map(
					appointmentResource => {
						const resourceName =
							resourcesNames.get(appointmentResource);
						return {
							label: resourceName,
							value: appointmentResource,
						};
					},
				);
				setResourcesOptions(resourcesOptions);
			} else {
				setResourcesOptions([]);
			}

			if (filters.tags) {
				const tagsOptions = filters.tags.map(tag => {
					const newTag = tagsNamesBySlug.get(tag);
					return {
						label: newTag?.name || '',
						value: newTag?.id || '',
						color: newTag?.color || '',
					};
				});

				setTagsOptions(tagsOptions as any);
			} else {
				setTagsOptions([]);
			}

			if (!filters.places) {
				setSelectedPlacesCheckbox([]);
			}

			if (filters.status) {
				const statuses = filters.status.map(status => {
					return {
						id: status,
						name: statusesMap.get(status) as string,
					};
				});

				setSelectedStatusCheckbox(statuses);
			} else {
				setSelectedStatusCheckbox([]);
			}

			if (!filters.is_confirmed) {
				setSelectedConfirmedCheckbox(null);
			}

			if (!filters.appointment__bypass) {
				setSelectedByPassCheckbox(null);
			}

			if (!filters.appointment__hold_resources) {
				setSelectedHoldResourcesCheckbox(null);
			}

			if (filters.deposit__status) {
        const statuses = filters.deposit__status.map((el: string)=>{
          return {
            label: depositMap.get(el),
            value: el
          }
        })
				setSelectedDepositStatusOptions(statuses);
			} else {
				setSelectedDepositStatusOptions([]);
			}

			if (filters.deposit__provider) {
        const statuses = filters.deposit__provider.map((el: string)=>{
          return {
            label: paymentProvidersMap.get(el),
            value: el
          }
        })
				setselectedPaymentProviderOptions(statuses);
			} else {
				setselectedPaymentProviderOptions([]);
			}

      if (filters.person) {
        setSelectedWithoutPerson({id: 'true',name: 'Да',})
      } else {
        setSelectedWithoutPerson(null)
      }

      if ('is_guest_appointment' in filters) {
        setIsGuestAppointment({
          id: filters.is_guest_appointment ? 'true' : 'false',
          name: filters.is_guest_appointment ? 'Да' : 'Нет',
        })
      } else {
        setIsGuestAppointment(null);
      }
		}

    if (!isProvidersGetted) {
      dispatch(getPaymentProviders({}));
      setIsProvidersGetted(true);
    }

    if (depositMap.size&&!depositStatusOptions.length) {
      const arr = [];

      for (const element of depositMap.entries()) {
        arr.push({
          label: element[1],
          value: element[0]
        })
      }

      setDepositStatusOptions(arr);
    }

    if (paymentProvidersMap.size&&!paymentProviderOptions.length) {
      const arr = [];

      for (const element of paymentProvidersMap.entries()) {
        arr.push({
          label: element[1],
          value: element[0]
        })
      }

      setPaymentProviderOptions(arr);
    }
	}, 
  [
    filters,
    resourcesNames,
    tagsForOrderMap,
    tagsNamesBySlug,
    paymentProvidersMap,
    isProvidersGetted,
    depositStatusOptions,
    paymentProviderOptions,
    setIsProvidersGetted,
    dispatch,
  ]);

	return {
		filters,
		resourcesOptions,
		tagsOptions,
		places,
		selectedResourcesOptions,
		selectedTagsOptions,
		selectedStatusCheckbox,
		selectedPlacesCheckbox,
		selectedConfirmedCheckbox,
    paymentProvidersMap,
    depositStatusOptions,
    selectedDepositStatusOptions,
    selectedByPassCheckbox,
    selectedWithoutPerson,
    defaultPersonId,
    paymentProviderOptions,
    selectedPaymentProviderOptions,
    selectedHoldResourcesCheckbox,
    isGuestAppointment,
		fetchDataWithDispatch,
		changeResources,
		changeTags,
		changeParticipantsStart,
		changeParticipantsEnd,
		changeStatusCheckbox,
		changePlacesCheckbox,
		changeConfirmed,
    changeDepositStatus,
    changeByPass,
    changeWithoutPerson,
    changeIsGuestAppointment,
    changePaymentProvider,
    changeHoldResources,

		getOrdersByFilter,
		reset,
	};
};
